export default "__VITE_ASSET__BzzH9wDr__"